import { List, ListSubheader, Stack, Typography } from '@mui/material';
import { Link as ReactRouterLink } from 'react-router-dom';
import { useAuthState } from 'state/useAuthState';
import { UserStatusChip } from 'components/UserStatusChip';
import { useTranslation } from 'react-i18next';
import { CoordinatesListItem } from 'components/CoordinatesListItem';
import { LocationDescriptor } from 'history';
import { MEMBERSHIP_PLANS } from 'features/membership/membership.constants';
import { getPaywallLink } from 'features/membership/membership.utils';

type CoordinatesListProps = {
  coordinates: { lat: number; lng: number };
  paywallSource: string;
};

type LinkButtonProps = {
  to: LocationDescriptor;
  component: typeof ReactRouterLink;
};

/**
 * @deprecated by 'pin_drop_improvements' flag - use <CoordinateSelector> instead
 */
export const CoordinatesList = (props: CoordinatesListProps): JSX.Element => {
  const { coordinates, paywallSource } = props;
  const { t } = useTranslation();
  const { showMembershipFeatures } = useAuthState();

  const disabled = !showMembershipFeatures;

  const getCoordinatesButtonProps = (): LinkButtonProps | undefined => {
    if (disabled) {
      const paywallLink = getPaywallLink({
        focusedPlan: MEMBERSHIP_PLANS.yearly,
        source: paywallSource,
      });
      return {
        component: ReactRouterLink,
        to: {
          pathname: paywallLink.pathname,
          search: paywallLink.search,
          state: {
            fromRoute: window.location.pathname + window.location.search,
          },
        },
      };
    }
    return undefined;
  };

  return (
    <List
      subheader={
        <ListSubheader variant="watchduty-section-header">
          <Stack direction="row" spacing={1} alignItems="center">
            <Typography variant="h3">
              {t('geoEvent.structuredInfo.initialLocation')}
            </Typography>
            <UserStatusChip type="members" />
          </Stack>
        </ListSubheader>
      }
    >
      <CoordinatesListItem
        coordinates={coordinates}
        format="decimal"
        buttonProps={getCoordinatesButtonProps()}
        blurred={disabled}
      />
      <CoordinatesListItem
        coordinates={coordinates}
        format="DDM"
        buttonProps={getCoordinatesButtonProps()}
        blurred={disabled}
      />
      <CoordinatesListItem
        coordinates={coordinates}
        format="DMS"
        buttonProps={getCoordinatesButtonProps()}
        blurred={disabled}
      />
    </List>
  );
};
